module.exports = __webpack_public_path__ + "img/logo.364fe65a.png";